export enum AlertBannerSeverity {
  Info = "info",
  Warning = "warning",
  Error = "error",
}

export interface AlertBannerResponse {
  response: AlertBannerContent[];
}

export interface AlertBannerContent {
  active?: string;
  id?: string;
  message?: string;
  severity?: AlertBannerSeverity;
  title?: string;
  urgent?: boolean;
}

export interface AlertBannerContentWithRequiredFields
  extends AlertBannerContent {
  id: string;
  message: string;
}
